import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── NonRental – Land ─────────────────────────────────────────────────────────

export const usePropertyCurrentPlattedLots = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.currentPlattedLots,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), currentPlattedLots: v } as IApplicationNonRental }));

export const usePropertyPlannedPlattedLots = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.plannedPlattedLots,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), plannedPlattedLots: v } as IApplicationNonRental }));

export const usePropertyWillBuildOnLandYourself = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.willBuildOnLandYourself,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), willBuildOnLandYourself: v } as IApplicationNonRental }));

export const usePropertyExitPlans = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.exitPlans,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), exitPlans: v } as IApplicationNonRental }));

export const usePropertyStartedSiteWork = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.startedSiteWork,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), startedSiteWork: v } as IApplicationNonRental }));

export const usePropertyRequiredZoningOrEntitlement = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.requiredZoningOrEntitlement,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), requiredZoningOrEntitlement: v } as IApplicationNonRental }));

export const usePropertyDescribeRequiredInspections = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.nonRental?.describeRequiredInspections,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), describeRequiredInspections: v } as IApplicationNonRental }));
